import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  clearGitOutput,
  selectLibrary,
} from "../library/librarySlice";

export default function GitOutputModal() {
  const dispatch = useAppDispatch();
  const librarySlice = useAppSelector(selectLibrary);
  const [activeTab, setActiveTab] = React.useState(0);

  const handleClose = () => {
    dispatch(clearGitOutput());
    setActiveTab(0);
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  if (!librarySlice.gitOutput) {
    return null;
  }

  const hasStdout = librarySlice.gitOutput.stdout && librarySlice.gitOutput.stdout.trim() !== "";
  const hasStderr = librarySlice.gitOutput.stderr && librarySlice.gitOutput.stderr.trim() !== "";

  // Determine which tab to show based on what's available
  const showTabs = hasStdout && hasStderr;
  const stdoutTabIndex = 0;
  const stderrTabIndex = hasStdout ? 1 : 0;

  return (
    <Dialog
      open={librarySlice.gitOutput !== undefined}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Git Command Output</DialogTitle>
      <DialogContent>
        <Box sx={{ p: 2 }}>
          {(hasStdout || hasStderr) ? (
            <>
              {showTabs && (
                <Tabs value={activeTab} onChange={handleTabChange}>
                  <Tab label="Stdout" />
                  <Tab label="Stderr" />
                </Tabs>
              )}
              {hasStdout && (!showTabs || activeTab === stdoutTabIndex) && (
                <Box sx={{ mt: 2 }}>
                  {!showTabs && <Typography variant="subtitle2" sx={{ mb: 1 }}>Stdout:</Typography>}
                  <pre
                    style={{
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                      margin: 0,
                      padding: "10px",
                      backgroundColor: "#f5f5f5",
                      borderRadius: "4px",
                      fontFamily: "monospace",
                      fontSize: "14px",
                      maxHeight: "60vh",
                      overflow: "auto",
                    }}
                  >
                    {librarySlice.gitOutput.stdout}
                  </pre>
                </Box>
              )}
              {hasStderr && (!showTabs || activeTab === stderrTabIndex) && (
                <Box sx={{ mt: 2 }}>
                  {!showTabs && <Typography variant="subtitle2" sx={{ mb: 1 }}>Stderr:</Typography>}
                  <pre
                    style={{
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                      margin: 0,
                      padding: "10px",
                      backgroundColor: "#fff0f0",
                      borderRadius: "4px",
                      fontFamily: "monospace",
                      fontSize: "14px",
                      maxHeight: "60vh",
                      overflow: "auto",
                      color: "#d32f2f",
                    }}
                  >
                    {librarySlice.gitOutput.stderr}
                  </pre>
                </Box>
              )}
            </>
          ) : (
            <Typography>No output available.</Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
